import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ComponentsModule } from '../../components/components.module';
import { TimesheetService } from '../timesheets/providers/timesheet.service';
import { SwipesPage } from './swipes';

@NgModule({
  declarations: [
    SwipesPage,
  ],
  imports: [
    IonicPageModule.forChild(SwipesPage),
    ComponentsModule
  ],
  providers: [ TimesheetService ]
})
export class SwipesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/swipes/swipes.module.ts